import React, { forwardRef, useEffect } from 'react'
import classes from './QrScanner.module.sass'
import { useQr } from '../hooks/useQr'

type Props = {
  onScan: (value: string) => void
}

export const QrScanner = forwardRef<HTMLVideoElement, Props>(({ onScan }, ref) => {
  const { modalActive, startScan, ref: qrRef } = useQr(onScan)

  useEffect(() => {
    startScan()
  }, [])

  useEffect(() => {
    if (qrRef && typeof qrRef !== 'function' && qrRef.current && ref) {
      if (typeof ref === 'function') {
        ref(qrRef.current)
      } else {
        ref.current = qrRef.current
      }
    }
  }, [qrRef, ref])

  if (!modalActive) return null

  return (
    <div className={classes.modal}>
      <div className={classes.qrContainer}>
        <video className={classes.qrReader} ref={qrRef} />
        <div className={classes.qrOverlay}>
          <div className={classes.qrFrame}>
            <div className={classes.qrLine} />
          </div>
        </div>
      </div>
    </div>
  )
})

QrScanner.displayName = 'QrScanner'